import { jsx as _jsx } from "react/jsx-runtime";
import React, {} from 'react';
import { isNonNullish, } from 'remeda';
export function cx(...parts) {
    return parts
        .filter(isNonNullish)
        .map(part => {
        if (typeof part === 'object') {
            return Object.entries(part)
                .filter(([_, isActive]) => isActive)
                .map(([css]) => css)
                .join(' ');
        }
        return part;
    })
        .join(' ');
}
export function depsEqual(a, b) {
    if (a.length !== b.length) {
        return false;
    }
    for (let i = 0; i < a.length; i++) {
        if (!Object.is(a[i], b[i])) {
            return false;
        }
    }
    return true;
}
function parseAttrs(rawAttrs) {
    const attrs = {};
    const attrRegex = /(\w+)=["']([^"']*)["']/g;
    for (const match of rawAttrs.matchAll(attrRegex)) {
        const name = match[1];
        const value = match[2];
        if (name !== undefined && value !== undefined) {
            attrs[name] = value;
        }
    }
    return attrs;
}
export function safeHref(href) {
    if (!href) {
        return '#';
    }
    try {
        const url = new URL(href, window.location.origin);
        const allowedProtocols = ['https:', window.location.protocol];
        if (!allowedProtocols.includes(url.protocol)) {
            return '#';
        }
        return url.href;
    }
    catch {
        return '#';
    }
}
export function renderRichText(text, components) {
    const regex = /<(\w+)([^>]*)>(.*?)<\/\1>/g;
    const parts = [];
    let lastIndex = 0;
    for (const match of text.matchAll(regex)) {
        const fullMatch = match[0];
        const tag = match[1];
        const rawAttrs = match[2];
        const content = match[3];
        if (tag === undefined
            || rawAttrs === undefined
            || content === undefined) {
            continue;
        }
        if (match.index > lastIndex) {
            parts.push(text.slice(lastIndex, match.index));
        }
        const renderer = components[tag];
        const attrs = parseAttrs(rawAttrs);
        if (renderer) {
            parts.push(_jsx(React.Fragment, { children: renderer(content, attrs) }, match.index));
        }
        else {
            parts.push(fullMatch);
        }
        lastIndex = match.index + fullMatch.length;
    }
    if (lastIndex < text.length) {
        parts.push(text.slice(lastIndex));
    }
    return parts;
}
export const defaultRichTextComponents = {
    a: (children, attrs) => (_jsx("a", { href: safeHref(attrs.href), target: attrs.target, children: children })),
};
//# sourceMappingURL=ReactUtils.js.map